<div class="form-group">
    @if (label) {
        <label class="ml-0"
            >{{ label }}
            @if (showRequiredOrOptional && required) {
                <span class="red">*</span>
            }
        </label>
    }
    @if (options) {
        <select (blur)="onTouched()" class="custom-select" [formControl]="control" [class.is-invalid]="isInvalid">
            @if (placeholder) {
                <option [ngValue]="null" [disabled]="!allowNull" selected>{{ placeholder }}</option>
            }
            @if (hasCategories) {
                @for (categoryGroup of options; let ci = $index; track ci) {
                    <optgroup [label]="getCategoryLabel(categoryGroup)">
                        @for (option of getCategoryOptions(categoryGroup); let oi = $index; track oi) {
                            <option [ngValue]="getOptionValue(option)" [innerHTML]="getOptionText(option)"></option>
                        }
                    </optgroup>
                }
            } @else {
                @for (option of options; let i = $index; track i) {
                    <option [ngValue]="getOptionValue(option)" [innerHTML]="getOptionText(option)"></option>
                }
            }
        </select>
    }

    @if (isInvalid && !hideError) {
        <div class="invalid-feedback">
            {{ errorMessage }}
        </div>
    }
</div>

